import React from 'react';
import './Solution2.css';
import data from '../../assets/Agreement-amico.png';
import { CardChecklist } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshakeAngle ,faSquarePollHorizontal , faChartLine , faDatabase , faMap} from '@fortawesome/free-solid-svg-icons';
function Solution2() {
  return (
    <section id="sol2" class="sol2">

      <div class="container" data-aos="fade-up">

      

         
        <div class="row sol2-icons" data-aos="fade-up">
        <div class="section-title">
          <h2>Project@DSF</h2>
 
        </div>
         

          <div class="row">

            <div class="col-xl-4 text-center" data-aos="fade-right" data-aos-delay="100">
              <img src={data} class="img-fluid p-2" alt=""  id="khrya"/>
            </div>

            <div class="col-xl-8 d-flex content">
              <div class="row align-self-center gy-4">

                <div class="col-md-6 icon-box" data-aos="fade-up">
                <FontAwesomeIcon icon={faHandshakeAngle} className='sol2_icon'/>
                  <div>
                    <h4>Collaborative partnership</h4>
                    <p>We work closely with our clients to understand their unique needs, challenges, and goals. By building a collaborative partnership, we can ensure that our solutions are tailored to the specific needs of each client.</p>
                  </div>
                </div>

                <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="100">
                <FontAwesomeIcon icon={faMap} className='sol2_icon'/>
                  <div>
                    <h4>Rigorous methodology</h4>
                    <p>We employ a rigorous methodology for accurate, reliable, and actionable data solutions. Our expert team utilizes advanced tools, techniques, and continuous innovation to ensure precision and value in our analyses .</p>
                  </div>
                </div>

                <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="200">
                <FontAwesomeIcon icon={faChartLine} className='sol2_icon'/>
                  <div>
                    <h4>Results-driven approach</h4>
                    <p>We are committed to delivering measurable results that drive business value. Our data solutions are designed to deliver tangible outcomes, such as increased revenue, improved operational efficiency, and enhanced customer experience</p>
                  </div>
                </div>

                <div class="col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                <FontAwesomeIcon icon={faSquarePollHorizontal} className='sol2_icon'/>
                  <div>
                    <h4>Continuous improvement</h4>
                    <p>We're dedicated to innovation in the ever-evolving data landscape. Continuously adopting new tools and techniques, we ensure our data solutions remain accurate and effective. Our commitment includes ongoing support for sustained relevance.</p>
                  </div>
                </div>

                <div class="col-md-6 icon-box mx-auto" data-aos="fade-up" data-aos-delay="400">
                <FontAwesomeIcon icon={faDatabase} className='sol2_icon'/>
                  <div>
                    <h4>Ethical and transparent</h4>
                    <p>We prioritize ethical responsibilities, maintaining the highest standards in our work. We offer transparency to clients regarding data collection, analysis, and usage, ensuring fairness, transparency, and utmost respect for individual privacy and data rights in our solutions.</p>
                  </div>
                </div>

                

              </div>
            </div>

          </div>

        </div>

      </div>

    </section>
    
  );
}

export default Solution2;
